<template>
  <div class="absolute fill-height events-page">
    <div class="absolute fill-height pb-3 gui-flex gui-flex-rows">
      <v-toolbar
      color="blue accent-3"
      dark
      extended
      flat
      class="toolbar__fixed"
        >
      </v-toolbar>

      <v-dialog
        v-model="dialogRemove"
        persistent
        max-width="500px"
        transition="dialog-transition"
        v-if="dialogRemove"
      >
        <v-card class="no__padding">
          <v-card-title>
            <h2>Smazat dodavatele</h2>
          </v-card-title>
          <v-card-text class="pt-0 pb-2">
            <p>Opravdu chcete smazat dodavatele <strong>{{detailItem.nazev}}</strong>?</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red elevation-0" dark @click="remove()" :loading="sending"><v-icon class="mr-2">delete</v-icon> Smazat</v-btn>
            <v-btn color="grey lighten-3 elevation-0" @click="dialogRemove=false">Zavřít</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="dialogCreate"
        persistent
        max-width="700px"
        transition="dialog-transition"
        v-if="dialogCreate"
      >
        <v-card class="no__padding">
          <v-card-title>
            <h2>Přidat dodavatele</h2>
          </v-card-title>
          <v-card-text class="pa-0" :class="{'pt-3 pl-3 pr-3 pb-1' : $vuetify.breakpoint.smAndUp}">
            <v-form ref="createForm">
              <v-layout row wrap>
                <v-flex xs12 sm3>
                  <v-text-field label="Zkratka dodavatele" class="mx-2" v-model="newItem.zkratka" :rules="rulesRequired"></v-text-field>
                </v-flex>
                <v-flex xs12 sm9>
                  <v-text-field label="Název dodavatele" class="mx-2" v-model="newItem.nazev" :rules="rulesRequired"></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field label="Pracovník dodavatele" class="mx-2" v-model="newItem.pracovnik"></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 sm6>
                  <v-text-field label="Telefon" class="mx-2" v-model="newItem.telefon"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field label="E-mail" class="mx-2" v-model="newItem.email"></v-text-field>
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-3 elevation-0" dark @click="create()" :loading="sending">Přidat</v-btn>
            <v-btn color="grey lighten-3 elevation-0" @click="dialogCreate=false">Zavřít</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="dialogDetail"
        persistent
        max-width="700px"
        transition="dialog-transition"
        v-if="dialogDetail"
      >
        <v-card flat class="no__radius pa-0 table-wrap__padding gui-flex-fill-rest gui-flex gui-flex-rows elevation-1">
          <v-card-title class="pl-0 pt-0">
            <h2>Detail dodavatele</h2>
          </v-card-title>
          <div class="gui-flex gui-flex-rows" v-if="!editMode">
            <v-card color="grey lighten-4 elevation-0" class="pa-0" :class="{'pt-3 pl-3 pr-3 pb-1' : $vuetify.breakpoint.smAndUp}">
              <v-card-text class="pa-0">
                <v-layout row wrap>
                  <v-flex xs12 sm6>
                    <p class="grey--text caption mb-1">Zkratka dodavatele:</p> <strong>{{detailItem.zkratka}}</strong>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <p class="grey--text caption mb-1">Název dodavatele:</p> <strong>{{detailItem.nazev}}</strong>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="mt-3">
                  <v-flex xs12>
                    <p class="grey--text caption mb-1">Pracovník pro korespondenci:</p> <strong>{{detailItem.pracovnik}}</strong>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="mt-3">
                  <v-flex xs12 sm6>
                    <p class="grey--text caption mb-1">Email:</p> <strong>{{detailItem.email}}</strong>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <p class="grey--text caption mb-1">Telefon:</p> <strong>{{detailItem.telefon}}</strong>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
            <v-card-actions class="mt-4">
              <v-layout row wrap>
                <v-flex grow :class="{'xs12':$vuetify.breakpoint.xs}">
                  <v-btn depressed color="primary" v-if="!editMode" @click="editClick()" :class="{'v-btn--block':$vuetify.breakpoint.xs}"><v-icon small class="mr-2">edit</v-icon>Upravit</v-btn>
                  <v-btn dark depressed color="red" :class="{'ml-0 my-2 v-btn--block':$vuetify.breakpoint.xs}" @click="dialogRemove=true"><v-icon small class="mr-2">delete</v-icon>Smazat</v-btn>
                </v-flex>
                <v-flex shrink :class="{'xs12':$vuetify.breakpoint.xs}">
                  <v-btn depressed color="grey lighten-3" :class="{'v-btn--block':$vuetify.breakpoint.xs}" @click="dialogDetail=false;editMode=false;" v-if="!sending">Zavřít</v-btn>
                </v-flex>
              </v-layout>
            </v-card-actions>
          </div>

          <div class="gui-flex gui-flex-rows" v-else>
            <v-card color="grey lighten-4" class="pt-3 pl-3 pr-3 pb-1 elevation-0">
              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs12 sm6>
                    <v-text-field label="Zkratka dodavatele" class="mx-2" v-model="editItem.zkratka"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field label="Název dodavatele" class="mx-2" v-model="editItem.nazev"></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="mt-3">
                  <v-flex xs12>
                    <v-text-field label="Pracovník pro korespondenci" class="mx-2" v-model="editItem.pracovnik"></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="mt-3">
                  <v-flex xs12 sm6 md6>
                    <v-text-field label="Email" class="mx-2" v-model="editItem.email"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field label="Telefon" class="mx-2" v-model="editItem.telefon"></v-text-field>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>

            <v-card-actions class="mt-4 text-xs-right">
              <v-btn color="primary" class="elevation-0 right" @click="edit()" :loading="sending"><v-icon small class="mr-2">save</v-icon>Uložit</v-btn>
              <v-spacer></v-spacer>
              <v-btn color="red" flat @click="editMode=false" class="right"><v-icon small class="mr-2">rotate_left</v-icon>Vrátit změny</v-btn>
            </v-card-actions>
          </div>
        </v-card>
      </v-dialog>

      <v-card flat class="no__radius mr-3 ml-3 table-wrap__padding wrap-scrollbar gui-flex-fill-rest gui-flex gui-flex-rows elevation-1">
        <Loader v-if="loading" skin="light"></Loader>
        <div v-else class="gui-flex gui-flex-rows">
          <div class="custom-scrollbar">
            <v-layout row wrap class="mb-3">
              <v-flex xs12 sm8>
                <h3>Seznam dodavatelů</h3>
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex xs12 sm4>
                <v-btn color="blue darken-3" class="ma-0 mb-3 right" :class="{'mt-3 v-btn--block': $vuetify.breakpoint.xs}" outline @click="createClick()">
                  <v-icon class="mr-2">add</v-icon>
                  Přidat dodavatele
                </v-btn>
              </v-flex>
            </v-layout>
            <div class="table-border__radius elevation-1">
              <v-data-table
                :headers="headers"
                :items="items"
                :pagination.sync="pagination"
                :total-items="pagination.totalItems"
                :rows-per-page-items="[25, 50, 100, 200]"
              >
                <template slot="items" slot-scope="props">
                  <td>{{ props.item.zkratka }}</td>
                  <td>{{ props.item.nazev }}</td>
                  <td>{{ props.item.pracovnik }}</td>
                  <td>{{ props.item.email }}</td>
                  <td>{{ props.item.telefon }}</td>
                  <td class="text-center">
                    <v-btn color="primary" class="elevation-0 ma-0" @click="detailClick(props.item)">
                      <v-icon small class="mr-2">remove_red_eye</v-icon> Detail
                    </v-btn>
                  </td>
                </template>
              </v-data-table>
            </div>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import Base from '@/pages/Base'
export default {
  extends: Base,
  data () {
    return {
      loading: false,
      editMode: false,
      headers: [
        { text: 'Zkratka dodavatele', value: 'zkratka' },
        { text: 'Název dodavatele', value: 'dodavatel' },
        { text: 'Pracovník dodavatele', value: 'pracovnik' },
        { text: 'Email', value: 'email' },
        { text: 'Telefon', value: 'telefon' },
        { text: 'Zobrazit', value: null, sortable: false, align: 'center' }
      ],
      items: [],
      removeItem: {},
      removing: false,
      dialogCreate: false,
      dialogRemove: false,
      dialogInit: { nazev: null, pracovnik: null, email: null, telefon: null, zkratka: null},
      newItem: null,
      dialogDetail: false,
      updating: false,
      sending: false,
      counter: 0,
      detailItem: null,
      editItem: null,
      rulesRequired: [
        (v) => !!v || "Pole je vyžadováno"
      ],
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 25,
        sortBy: "zkratka",
        totalItems: 0
      },
    }
  },
  mounted: function() {
    window.MenuListener.show();
    this.load();
  },
  props: {
    id: String
  },
  methods: {
    queryList: function() {
      if (this.timeout != null)
        clearTimeout(this.timeout);
      this.timeout = setTimeout(function() {
        this.pagination.page = 1;
        this.load();
      }.bind(this), 200)
    },
    load: function() {
      this.counter++;
      this.loadingTable = true;
      window.API.post("dodavatele/search", {
        pagination: this.pagination,
        s: this.search,
        echo: this.counter
      }).then(function(body) {
        if (this.counter != body.echo)
          return;
        this.items = body.data;
        this.pagination.sortBy = body.sort.sortBy;
        this.pagination.descending = body.sort.descending;
        this.pagination.page = body.sort.page;
        this.pagination.rowsPerPage = body.sort.rowsPerPage;
        this.pagination.totalItems = body.sort.totalItems;
        this.loading = false;
        this.loadingTable = false;
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    },
    createClick () {
      this.newItem = window.th.copy(this.dialogInit);
      this.dialogCreate = true;
    },
    create () {
      if (this.$refs.createForm.validate()) {
        this.sending = true;
        window.API.post("dodavatele", this.newItem).then(function(body) {
          if (body.inserted) {
            this.load();
            this.dialogCreate = false;
          }
          this.sending = false;
        }.bind(this)).catch(function(err) {
          console.log(err);
          this.sending = false;
        }.bind(this));
      }
    },
    detailClick (e) {
      this.detailItem = window.th.copy(e);
      this.dialogDetail = true;
    },
    editClick () {
      this.editItem = window.th.copy(this.detailItem);
      this.editMode = true;
    },
    edit () {
      this.sending = true;
      window.API.put("dodavatele/" + this.detailItem.id, this.editItem).then(function(body) {
        if (body.updated) {
          this.load();
          this.editMode = false;
          this.dialogDetail = false;
        }
        this.sending = false;
      }.bind(this)).catch(function(err) {
        console.log(err);
        this.sending = false;
      }.bind(this));
    },
    remove () {
      this.removing = true;
      window.api.delete("dodavatele/" + this.detailItem.id).then((_body) => {
        if (_body.deleted) {
          this.dialogDetail = false;
          this.load();
        }
        this.removing = false;
      }).catch((err) => {
        console.log(err);
        this.removing = false;
      });
      this.dialogRemove = false;
    },
  },
  components: {

  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Dodavatele/SeznamDodavatelu.vue